import React from 'react'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'

import Grid from '@material-ui/core/Grid'

import Recherche from 'EurestoComponents/Recherche'
import Search from '../Search/Produit'

import moment from 'moment'
import Avatar from 'Components/Avatar'
import Data from 'EurestoClass/Data'

moment.locale('fr')

export default class extends React.Component {

  constructor (props) {
    super(props)
  }

  render () {
    const columns = [
      { Header: 'id', accessor: 'id', show: false },
      {
        Header: () => <span style={{ cursor: 'not-allowed' }}><i className="EurestoPrimary--text ei-module_gestion"
                                                                 aria-hidden="true"/></span>,
        id: 'entite',
        sortable: false,
        width: 48,
        Cell: (row) => {
          return (
            <div style={{ position: 'relative' }}>
              <Avatar
                type={'produit'}
                src={row.original.media_lien}
                style={{ width: '45px', height: '45px', padding: 5 }}/>
            </div>
          )
        },
      },
      {
        Header:
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
                alignItems={'center'}>
            <b>{EurestoI18n.t('commun:Nom')}</b>
          </Grid>,
        accessor: 'libelle',
        minWidth: 300,
        Cell: (row) => {
          return (
            <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
                  alignItems={'center'}><b>{row.original.libelle}</b>
            </Grid>
          )
        },
      }, {
        Header: () => <span>{EurestoI18n.t('crm:Rubrique')}</span>,
        accessor: 'rubrique_id',
        width: 200,
        Cell: (row) => {
          let rubriqueFound = {}
          if (row.original.rubrique_id) {
            rubriqueFound = Data.get(Constants.module.GESTION, Constants.donnee.rubrique, { id: row.original.rubrique_id }) || {}
          }

          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                       alignItems={'center'}>
            {rubriqueFound.libelle}
          </Grid>
        },
      }, {
        Header: () => <span>{EurestoI18n.t('crm:Famille')}</span>,
        accessor: 'famille_id',
        width: 200,
        Cell: (row) => {
          let familleFound = {}
          if (row.original.famille_id) {
            familleFound = Data.get(Constants.module.GESTION, Constants.donnee.famille, { id: row.original.famille_id }) || {}
          }

          if (familleFound.famille_id) {
            familleFound = Data.get(Constants.module.GESTION, Constants.donnee.famille, { id: familleFound.famille_id }) || {}
          }

          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                       alignItems={'center'}>
            {familleFound.libelle}
          </Grid>
        },
      }, {
        Header: () => <span>{EurestoI18n.t('crm:Sous-Famille')}</span>,
        id: 'famille_id',
        width: 200,
        Cell: (row) => {
          let familleFound = {}
          if (row.original.famille_id) {
            familleFound = Data.get(Constants.module.GESTION, Constants.donnee.famille, { id: row.original.famille_id }) || {}
          }

          if (!familleFound.famille_id) {
            familleFound = {}
          }

          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                       alignItems={'center'}>
            {familleFound.libelle}
          </Grid>
        },
      }, {
        Header: () => <span>{EurestoI18n.t('crm:Unité')}</span>,
        id: 'unite_id',
        width: 200,
        Cell: (row) => {
          let uniteFound = {}
          if(row.original.stocks && row.original.stocks.length > 0) {
            const uniteRef = row.original.stocks.find(stock => stock.type_unite_id === 1) || {}
            uniteFound = Data.get(Constants.module.GESTION, Constants.donnee.unite, { id: uniteRef.unite_id })
          }

          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                       alignItems={'center'}>
            {uniteFound.libelle}
          </Grid>
        },
      },
    ]

    return (
      <Recherche
        showSearch={this.props.showSearch}
        searchComponent={
          <Search defaultSearch={this.props.defaultSearch}
                  search={this.props.search || 'gestion_produit_' + (this.props.name || '') + User.Entite.get().id}/>
        }
        view={this.props.view}
        data={this.props.data}
        type={'list'}
        style={this.props.style}
        onClick={this.props.onClick}
        columns={columns}
        search={this.props.search || 'gestion_produit_' + (this.props.name || '') + User.Entite.get().id}
      />
    )
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Table/Produit.js